/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { FINAL_OUTCOME_LABEL } from '../constants';

// Desfecho final (só quando encerrado/admitido). Admitido = positivo (verde);
// desistência/recusa/ausência = âmbar; reprovação/desqualificação = vermelho.
const OUTCOME_VARIANT = {
   ADMITIDO: 'green',
   DESISTIU: 'amber',
   RECUSA_DE_VAGA: 'amber',
   NAO_COMPARECEU: 'amber',
   REPROVADO: 'red',
   INCOMPATIVEL: 'red',
   DESQUALIFICADO: 'red',
};

export default function FinalOutcomeBadge({ value }) {
   if (!value) return null;
   return (
      <StatusBadge variant={OUTCOME_VARIANT[value] ?? 'neutral'}>
         {FINAL_OUTCOME_LABEL[value] ?? value}
      </StatusBadge>
   );
}

FinalOutcomeBadge.propTypes = {
   value: PropTypes.string,
};
